import styled from 'styled-components'
export default styled.div`
  display: inline-block;
  vertical-align: middle;
  top: 0;
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/VerticalCentered.js